import type { ReactElement } from 'react'
import React from 'react'
import { Text, csx, cx } from '@vtex/admin-ui'

import type { ListItemProps } from '../../../../components'
import { ListItem } from '../../../../components'
import { Icon } from '../../../../../../ui/components/Icon'

export type OptionItemProps = {
  icon: SpriteSymbol | ReactElement
} & ListItemProps

export const OptionItem = ({
  icon,
  className = '',
  children,
  ...props
}: OptionItemProps) => {
  return (
    <ListItem
      className={cx(
        csx({
          display: 'flex',
          alignItems: 'center',
          minHeight: '3.75rem',
          cursor: 'pointer',
          ':hover': {
            opacity: 0.5,
          },
        }),
        className
      )}
      {...props}
    >
      <Icon
        className={csx({
          width: '$space-5',
          height: '$space-5',
        })}
      >
        {icon}
      </Icon>
      <Text
        variant="action2"
        className={csx({
          marginLeft: '$space-5',
          ':hover': {
            opacity: 0.5,
          },
        })}
      >
        {children}
      </Text>
    </ListItem>
  )
}
